  // Set up your root reducer here...
  import { combineReducers } from 'redux';
  import { routerReducer } from 'react-router-redux';
  import selectionReducer from './selectionReducer';
  import dataReducer from './dataReducer';

  const rootReducer = combineReducers({
    configurator: selectionReducer,
    data: dataReducer,
    routing: routerReducer
  });

  export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js